module.exports = __webpack_public_path__ + "static/img/004txt-03.ac1679ca.png";